import { findCurrUser, getResuorceBySysAuth, changeLanKey, getCloudMenu, menuMerge, queryLanguageSource } from '@/common/js/user';
import lang from '@/lang/index';
import config from '@/config/user.env';
import cookie from 'js-cookie';
import { systemMark } from '@/utils/tool';

const { appId } = window.environment;

export default {
  state: {
    user: { },
    authority: [],
    appId: config.appId,
    lang: { },
    isNewMenu: true,
    languageSource: 'local', // 国际化配置来源
    supplierInfo: {},
  },
  getters: {
    user: state => state.user,
    appId: state => state.appId,
    authority: state => state.authority,
    menus: state => {
      if (state.authority) {
        return state.authority;
      }
      return [];
    },
    lang: state => state.lang,
    isNewMenu: state => state.isNewMenu,
    supplierInfoGetter: state => state.supplierInfo,
  },
  mutations: {
    updateUserInfo(state, user) {
        user.fdLangType = user.fdLangType === 'ja-JP' ? 'th' : user.fdLangType;
        state.user = user;
        cookie.set('oam_locale', changeLanKey(user.fdLangType), { domain: '.midea.com' });
      if (!state.isNewMenu) {
        cookie.set('oam_locale', changeLanKey(user.fdLangType), { domain: '.midea.com' });
      }
    },
    updateAuthority(state, authority) {
      state.authority = authority;
        // cookie.set('oam_locale', changeLanKey(authority[0].fdLangType), { domain: '.midea.com' });
    },
    updateLang(state, _lang) {
      state.lang = _lang;
    },
    /* 切换菜单 */
    menuSwitch(state, isNewMenu) {
        state.isNewMenu = isNewMenu;
    },
    UPDATE_LANGUAGE_SOURCE(state, data) {
        state.languageSource = data;
    },
    /* 更新user信息 */
    switchUpdateUser(state, user) {
        state.user = user;
    },
    updateSupplierInfo(state, data) {
        state.supplierInfo = data;
    },
  },
  actions: {
    /**
     * 初始化系统
     * @param {*} param0
     */
    initSystem({ commit }) {
        cookie.set('appId', appId);
        return new Promise((resolve) => {
            /* 查询字典，判断是否使用新菜单 */
            const isNewMenu = true;
            // axios.get('/gscint/sys/sysParam/queryDictionaryData?dictCode=INT_MENU_SWITCH&isValid=Y')
            // .then((res) => {
            //     const data = res.data.data;
            //     if (data && data.length > 0) {
            //         isNewMenu = true;
            //     }
            // })
            // .finally(() => {
            // })
            commit('menuSwitch', isNewMenu);
            resolve(Promise.all([findCurrUser(), getResuorceBySysAuth(isNewMenu), getCloudMenu(isNewMenu), queryLanguageSource()]).then(res => {
                if (res[0].success && res[1].success) {
                  commit('updateUserInfo', res[0].data.user);
                  commit('updateAuthority', isNewMenu ? menuMerge(res[1].data.code !== '-1' ? res[1].data.datas : [], res[2].data) : res[1].data);
                }
                const { data, status } = (res[3] && res[3].data) || {};
                if (status === 0 && data) {
                    commit('UPDATE_LANGUAGE_SOURCE', data[0] && data[0].entryCode);
                };
                return res[0].success && res[1].success;
            }));
        });
    },
    UPDATE_LANG({ commit, state }) {
        const language = localStorage.getItem('int-language');
        const obj = state.authority.find((item) => item.fdKey === systemMark());
        const langSettings = lang.initLanguage(state.isNewMenu ? (obj ? obj.fdLangType: '') : (language || state.user.fdLangType));
        commit('updateLang', langSettings);
        return langSettings;
    },
  },
};
